export const onlyNumbers = (s: string): string => {
  return s.replace(/\D/g, '');
};
